import BaseService from '../base.service';
import store from '@/store';

const locationService = class LocationService extends BaseService {
    url!: string
    constructor () {
      super();
    }

    getAllLocations (page = 1) {
      this.url = `${this.baseURL}locations?page=${page}`;
      return super.get(this.url);
    }

    newLocationFormData (payload = {}, lang = 'en-us') {
      this.headers['Accept-Language'] = lang;
      this.headers['Content-Type'] = 'multipart/form-data';
      const url = this.baseURL + 'locations';

      return super.post(url, payload);
    }

    newLocation (payload: Record<string, any> = {}) {
      const url = this.baseURL + 'locations';

      return super.post(url, payload);
    }

    updateLocation (payload: Record<string, any> = {}, locationId: string, lang = 'en-us') {
      this.headers['Accept-Language'] = lang;
      const url = this.baseURL + `locations/${locationId}`;

      return super.patch(url, payload);
    }

    updateLocationFormData (payload: Record<string, any> = {}, locationId: string, lang = 'en-us') {
      this.headers['Accept-Language'] = lang;
      this.headers['Content-Type'] = 'multipart/form-data';

      const url = this.baseURL + `locations/${locationId}`;

      return super.post(url, payload);
    }

    removeLocation (locationId: string) {
      const url = this.baseURL + `locations/${locationId}`;

      return super.remove(url, {});
    }

    fetchLocation (locationId: string, lang = 'en-us') {
      this.headers['Accept-Language'] = lang;
      const url = this.baseURL + `locations/${locationId}?include=delivery-areas`;
      return super.get(url, {}, this.headers);
    }

    fetchLocations (lang = 'en-us', page = 1, limit = 100) {
      this.headers['Accept-Language'] = lang;
      // let url = this.baseURL + `locations?filter[status]=active&include=delivery-areas&limit=50&page=${page}`;
      const url = this.baseURL + `locations?filter[delivery]=all&filter[enabled]=all&include=delivery-areas&limit=${limit}&page=${page}`;

      return super.get(url);
    }

    fetchLocationsActive (lang = 'en-us', page = 1) {
      this.headers['Accept-Language'] = lang;
      // let url = this.baseURL + `locations?filter[status]=active&include=delivery-areas&limit=50&page=${page}`;
      const url = this.baseURL + `locations?filter[delivery]=all&include=delivery-areas&limit=100&page=${page}`;

      return super.get(url);
    }

    validateLocation (lat: string | number, lng: string | number) {
      const url = this.baseURL + 'locations?filter[delivery-area.lat]=' + lat + '&filter[delivery-area.long]=' + lng;

      return super.get(url);
    }

    fetchNearestLocations (lat: string | number, lng: string | number) {
      const url = this.baseURL + 'locations?_lat=' + lat + '&_long=' + lng;

      return super.get(url);
    }

    fetchDrivers (locationId: string) {
      const url = this.baseURL + 'employees';
      return super.get(url, {
        'filter[location]': locationId,
      });
    }

    assignDriver (payload: Record<string, any> = {}, employeeId: string) {
      const url = this.baseURL + `employees/${employeeId}/orders`;

      return super.post(url, payload);
    }

    deliveryAreas (storeId: string, page = 1, perPage = 15) {
      const url = this.baseURL + `locations/${storeId}/delivery-areas?page=${page}&per-page=${perPage}`;

      return super.get(url);
    }

    updateDeliveryArea (payload: Record<string, any> = {}, storeId: string, areaId: string) {
      const url = this.baseURL + `locations/${storeId}/delivery-areas/${areaId}`;

      return super.patch(url, payload);
    }

    deleteDeliveryArea (storeId: string, areaId: string) {
      const url = this.baseURL + `locations/${storeId}/delivery-areas/${areaId}`;

      return super.remove(url, {});
    }

    createArea (payload: Record<string, any> = {}, storeId: string) {
      const url = this.baseURL + `locations/${storeId}/delivery-areas`;

      return super.post(url, payload);
    }

    disableLocation (payload: Record<string, any> = {}, storeId: string) {
      const url = this.baseURL + `locations/${storeId}/inactive-items`;

      return super.post(url, payload);
    }

    removeDisabledLocation (storeId: string, itemId: string) {
      const url = this.baseURL + `locations/${storeId}/inactive-items/${itemId}`;

      return super.remove(url, {});
    }

    locationInactiveModifiers (payload: Record<string, any> = {}, storeId: string|number) {
      const url = `${this.baseURL}locations/${storeId}/inactive-modifiers`;

      return super.post(url, payload);
    }

    removeInactiveModifiers (storeId: string|number, itemId: string|number) {
      const url = `${this.baseURL}locations/${storeId}/inactive-modifiers/${itemId}`;

      return super.remove(url, {});
    }
};

export default locationService;
